import styled from 'styled-components';

import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledLeftContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;
	user-select: none;
	pointer-events: none;

	${Text} {
		font-weight: 400;
		font-size: 18px;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledRightContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 40px;
`;

const StyledMoneyContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;
	height: 40px;
	padding: 0 10px;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	user-select: none;
	pointer-events: none;

	${Text} {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledCrossContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 40px;
	height: 40px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.1);
	cursor: pointer;
	transition: background-color 0.3s ease;

	img {
		transition: filter 0.3s ease;
		user-select: none;
		pointer-events: none;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

const StyledDivider = styled.div`
	width: 100%;
	height: 1px;
	margin-top: 40px;
	background-color: rgba(255, 255, 255, 0.1);
`;

export {
	StyledContainer,
	StyledCrossContainer,
	StyledDivider,
	StyledLeftContainer,
	StyledMoneyContainer,
	StyledRightContainer,
};
